import { connect } from 'react-redux'
import contactUs from './contactUs'
const mapStoreToProps = state => ({
})
const mapDispatchToProps = dispatch => ({
  // applyFilters:(filter_string)=>dispatch(applyFilters(filter_string))
})

 export default connect(mapStoreToProps, mapDispatchToProps)(contactUs)
